import * as React from "react";
import {WPTable} from "shared/controls/WPTable/WPTable";
import {WPBasicColumn} from "shared/controls/WPTable/Columns/WPBasicColumn";
import {Checkbox} from "@material-ui/core";
import {ToastService} from "shared/utilities/services/ToastService";


let createColumn=require('../../../../../js/formBuilder/sfAnalytics').CreateColumn;

export class Table extends React.Component<TableProps, TableState> {
    static defaultProps: Partial<TableProps> = {
        PageSize:50,
        RowCount:0,
        Index:0
    };


    public Columns:any[];
    public Entries:any[];
    public Height:number;

    constructor(props: TableProps) {
        super(props);
        this.Height=undefined;
        this.RegenerateColumns(props.FormElements,props.Entries);
        this.state = {};
    }

    componentWillReceiveProps(nextProps: Readonly<TableProps>, nextContext: any): void {
        if(nextProps!=this.props||nextProps.FormElements!=nextProps.FormElements)
        {
            this.RegenerateColumns(nextProps.FormElements,nextProps.Entries);

        }
    }

    public render() {
        return (
            <div style={{height:this.Height}}>
                <WPTable PageSizeChanged={x=>this.props.PageSizeChanged&&this.props.PageSizeChanged(x)} AvailablePageSizes={this.props.AvailablePageSize} FitToScreen={true} RowClicked={x=>this.props.ViewRows([x])} PageChanged={x=>this.props.PageChanged(x)} IsSelectable={true} EmptyContent={this.GetEmptyContent()} Data={this.Entries} Size={this.props.PageSize} PageIndex={this.props.Index} RowsCount={this.props.RowCount} ActionClicked={(action,row)=>this.ActionClicked(action,row)}
                         BulkActions={[
                             {Title:'Delete',CallBack:(()=>this.DeleteSelection())},
                             {Title:'View',CallBack:(()=>this.ViewSelection())}

                         ]}>
                    {[

                        this.Columns.map((x,i)=>
                            <WPBasicColumn Raw={true} PropertyName={x.index} Title={x.label} key={x.index}  Actions={i==0?[
                                {Title:'View',ClassName:'',Id:'view'},
                                {Title:'Edit',ClassName:'',Id:'edit'},
                                {Title:'Delete',ClassName:'rnDeleteAction',Id:'delete'}
                            ]:[]} IsClickable={i==0} />
                        )
                        ]
                    }
                </WPTable>
            </div>
        )
    }

    private RegenerateColumns(formElements: any,entries:any[]) {
        this.Columns=[];
        this.Entries=[];
        debugger;
        if(formElements!=null)
        {
            for(let field of formElements)
            {
                let columns=createColumn(field as any);

                if(columns!=null)
                    this.Columns=this.Columns.concat(columns);

            }
        }
        if(entries==null) {
            this.forceUpdate();
            return;
        }

        for(let unprocessedEntry of entries)
        {
            let row:any={};

            for(let column of this.Columns)
            {
                row[column.index]=column.formatter(null,{colModel:column},unprocessedEntry);
            }
            row._Date=unprocessedEntry.date;
            row._EntryId=unprocessedEntry.entry_id;
            row._UserName=unprocessedEntry.user_name;
            row._UserId=unprocessedEntry.user_id;
            row._Ip=unprocessedEntry.user_ip;
            this.Entries.push(row);

        }
        this.forceUpdate();
    }

    private GetEmptyContent() {
        return(
            <div style={{textAlign:'center'}}>
                Nothing to show yet
            </div>
        )
    }



    private DeleteSelection() {
        if(!this.Entries.find(x=>x.Selected))
        {
            ToastService.SendErrorMessage('You need to select a row first');
            return false;
        }

        this.props.DeleteRows(this.Entries.filter(x=>x.Selected));
        return false;

    }

    private ActionClicked(action: string, row: any) {
        switch (action) {
            case 'delete':
                this.props.DeleteRows([row]);
                break;
            case 'edit':
                this.props.EditRow(row);
                break;
            case 'view':
                this.props.ViewRows([row]);
                break;
        }
    }

    private ViewSelection() {
        if(!this.Entries.find(x=>x.Selected))
        {
            ToastService.SendErrorMessage('You need to select a row first');
            return false;
        }

        this.props.ViewRows(this.Entries.filter(x=>x.Selected));
        return false;
    }
}


//#region ----------------------------------------------------"State and props"------------------------------------------------------------------------------------
interface TableProps {
    Entries:any;
    FormElements:any;
    PageSize:number;
    AvailablePageSize:{Label:string,Size:number}[];
    RowCount:number;
    Index:number;
    DeleteRows:(rows:any[])=>void;
    EditRow:(rows:any)=>void;
    PageChanged:(index:number)=>void;
    ViewRows:(rows:any[])=>void;
    PageSizeChanged:(size:number)=>void;
}

interface TableState {

}

//#endregion "My Region"